import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`:host {
    box-sizing: border-box;
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--inv-grid-gutter-x, 1.5em) * 0.5);
    padding-left: calc(var(--inv-grid-gutter-x, 1.5em) * 0.5);
    margin-top: var(--inv-grid-gutter-y, 0);
}
:host(.col) {
    flex: 1 0 0%;
}
:host(.col-auto) {
    flex: 0 0 auto;
    width: auto;
}
:host(.col-1) {
    flex: 0 0 auto;
    width: 8.33333333%;
}
:host(.col-2) {
    flex: 0 0 auto;
    width: 16.66666667%;
}
:host(.col-3) {
    flex: 0 0 auto;
    width: 25%;
}
:host(.col-4) {
    flex: 0 0 auto;
    width: 33.33333333%;
}
:host(.col-5) {
    flex: 0 0 auto;
    width: 41.66666667%;
}
:host(.col-6) {
    flex: 0 0 auto;
    width: 50%;
}
:host(.col-6) {
    flex: 0 0 auto;
    width: 50%;
}
:host(.col-7) {
    flex: 0 0 auto;
    width: 58.33333333%;
}
:host(.col-8) {
    flex: 0 0 auto;
    width: 66.66666667%;
}
:host(.col-9) {
    flex: 0 0 auto;
    width: 75%;
}
:host(.col-10) {
    flex: 0 0 auto;
    width: 83.33333333%;
}

:host(.col-11) {
    flex: 0 0 auto;
    width: 91.66666667%;
}

:host(.col-12) {
    flex: 0 0 auto;
    width: 100%;
}

@media (min-width: 576px) {
    :host(.col-sm-auto) {
        flex: 0 0 auto;
        width: auto;
    }

    :host(.col-sm-1) {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    :host(.col-sm-2) {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    :host(.col-sm-3) {
        flex: 0 0 auto;
        width: 25%;
    }

    :host(.col-sm-4) {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    :host(.col-sm-5) {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    :host(.col-sm-6) {
        flex: 0 0 auto;
        width: 50%;
    }

    :host(.col-sm-7) {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    :host(.col-sm-8) {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    :host(.col-sm-9) {
        flex: 0 0 auto;
        width: 75%;
    }

    :host(.col-sm-10) {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    :host(.col-sm-11) {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    :host(.col-sm-12) {
        flex: 0 0 auto;
        width: 100%;
    }
}
@media (min-width: 768px) {
    :host(.col-md-auto) {
        flex: 0 0 auto;
        width: auto;
    }

    :host(.col-md-1) {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    :host(.col-md-2) {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    :host(.col-md-3) {
        flex: 0 0 auto;
        width: 25%;
    }

    :host(.col-md-4) {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    :host(.col-md-5) {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    :host(.col-md-6) {
        flex: 0 0 auto;
        width: 50%;
    }

    :host(.col-md-7) {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    :host(.col-md-8) {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    :host(.col-md-9) {
        flex: 0 0 auto;
        width: 75%;
    }

    :host(.col-md-10) {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    :host(.col-md-11) {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    :host(.col-md-12) {
        flex: 0 0 auto;
        width: 100%;
    }
}
@media (min-width: 992px) {
    :host(.col-lg-auto) {
        flex: 0 0 auto;
        width: auto;
    }

    :host(.col-lg-1) {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    :host(.col-lg-2) {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    :host(.col-lg-3) {
        flex: 0 0 auto;
        width: 25%;
    }

    :host(.col-lg-4) {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    :host(.col-lg-5) {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    :host(.col-lg-6) {
        flex: 0 0 auto;
        width: 50%;
    }

    :host(.col-lg-7) {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    :host(.col-lg-8) {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    :host(.col-lg-9) {
        flex: 0 0 auto;
        width: 75%;
    }

    :host(.col-lg-10) {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    :host(.col-lg-11) {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    :host(.col-lg-12) {
        flex: 0 0 auto;
        width: 100%;
    }
}
@media (min-width: 1200px) {
    :host(.col-xl-auto) {
        flex: 0 0 auto;
        width: auto;
    }

    :host(.col-xl-1) {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    :host(.col-xl-2) {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    :host(.col-xl-3) {
        flex: 0 0 auto;
        width: 25%;
    }

    :host(.col-xl-4) {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    :host(.col-xl-5) {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    :host(.col-xl-6) {
        flex: 0 0 auto;
        width: 50%;
    }

    :host(.col-xl-7) {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    :host(.col-xl-8) {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    :host(.col-xl-9) {
        flex: 0 0 auto;
        width: 75%;
    }

    :host(.col-xl-10) {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    :host(.col-xl-11) {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    :host(.col-xl-12) {
        flex: 0 0 auto;
        width: 100%;
    }
}
@media (min-width: 1400px) {
    :host(.col-xxl-auto) {
        flex: 0 0 auto;
        width: auto;
    }

    :host(.col-xxl-1) {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    :host(.col-xxl-2) {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    :host(.col-xxl-3) {
        flex: 0 0 auto;
        width: 25%;
    }

    :host(.col-xxl-4) {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    :host(.col-xxl-5) {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    :host(.col-xxl-6) {
        flex: 0 0 auto;
        width: 50%;
    }

    :host(.col-xxl-7) {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    :host(.col-xxl-8) {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    :host(.col-xxl-9) {
        flex: 0 0 auto;
        width: 75%;
    }

    :host(.col-xxl-10) {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    :host(.col-xxl-11) {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    :host(.col-xxl-12) {
        flex: 0 0 auto;
        width: 100%;
    }
}
`); export default styleSheet;